<template>
    <!-- Header -->
    <header class="border-b border-gray-200 bg-gradient-to-br from-slate-50 to-slate-100 py-5">
        <div class="max-w-7xl mx-auto px-5">
            <nav class="flex items-center text-sm text-slate-600 mb-2">
                <button @click="window.history.back()" class="text-slate-700 font-medium transition-colors duration-200">
                    Collections
                </button>
                <span class="mx-2 text-slate-400">›</span>
                <span class="text-slate-700">{{ collection.nom }}</span>
            </nav>
        </div>
    </header>
    <!-- Présentation de la collection -->
    <section class="bg-gray-50 py-10 pb-20">
        <div class="max-w-7xl mx-auto px-5">
            <div class="text-center py-12">
                <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2A3993] mb-6">
                    {{ collection.nom }}
                </h1>
                <p class="text-lg text-slate-600 mt-6 max-w-3xl mx-auto">
                    Parcourez les ouvrages de cette collection et découvrez une sélection variée de titres soigneusement choisis.
                </p>
            </div>

            <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                <div
                    v-for="(book, idx) in filteredBook"
                    :key="book.id"
                    @click="showDetail(book)"
                    class="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer border border-gray-100 hover:border-[#ff7e41]/30"
                    :style="{ animationDelay: `${idx * 0.05}s` }"
                >
                    <!-- Image + badges -->
                    <div class="relative overflow-hidden">
                        <img
                            :src="book.banners"
                            :alt="book.title"
                            class="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-700"
                        />
                        <!-- Type -->
                        <div class="absolute top-3 left-3">
              <span
                  class="px-3 py-1 text-white text-xs font-bold rounded-full shadow-lg"
                  :class="book.book_type"
              >
                {{ book.book_type }}
              </span>
                        </div>
                        <!-- Note -->
                        <div class="absolute top-3 right-3 bg-white/90 px-2 py-1 rounded-full">
                            <div class="flex items-center space-x-1">
                                <svg class="w-3 h-3 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                </svg>
                                <span class="text-xs font-bold text-gray-700">{{ book.evaluation || '0' }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Contenu -->
                    <div class="p-5">
                        <h3 class="font-bold text-gray-900 mb-2 line-clamp-2 text-lg group-hover:text-[#ff7e41] transition-colors">
                            {{ book.title }}
                        </h3>
                        <p class="text-gray-600 text-sm mb-3 font-medium">{{ book.authors }}</p>
                        <div class="flex items-center justify-between text-xs text-gray-500">
              <span class="flex items-center space-x-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
                </svg>
                <span>{{ book.pages }} pages</span>
              </span>
                            <span class="font-semibold text-[#ff7e41]">{{ book.book_type || 'Non défini' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty state -->
            <div v-if="filteredBook.length === 0" class="text-center py-20">
                <div class="max-w-xs mx-auto">
                    <svg class="w-16 h-16 text-slate-400 mx-auto mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
                    </svg>
                    <h3 class="text-xl font-semibold text-slate-700 mb-2">Aucun ouvrage dans cette collection</h3>
                    <p class="text-slate-500">Revenez plus tard, de nouveaux titres arrivent bientôt !</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue'
import { route } from '@/helper.js'

const props = defineProps({
    collection: Object,
    books: Array
})
console.log(props.books)
const filteredBook = computed(() => props.books)

function showDetail(book) {
    window.location.href = route('show-book', { book: book.id,slug:book?.slug });
}

function excerpt(text) {
    if (!text) return ''
    return text.length > 300 ? text.slice(0, 300) + '…' : text
}
</script>

<style scoped>
@keyframes fade-in-up {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
.animate-fade-in-up {
    animation: fade-in-up 0.6s ease-out forwards;
    opacity: 0;
}
</style>
